import { render, staticRenderFns } from "./editAlertNumSubmit.vue?vue&type=template&id=2b65b65a&scoped=true&"
import script from "./editAlertNumSubmit.vue?vue&type=script&lang=js&"
export * from "./editAlertNumSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editAlertNumSubmit.vue?vue&type=style&index=0&id=2b65b65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65b65a",
  null
  
)

export default component.exports